import type { Tile } from '../../context/ContentContext/contentTypes';
import { getPreviouslyVisited } from '../getPreviouslyVisited';
import { getModelNameFromUrl } from '../tracker/getModelNameFromUrl';
import { getPageTypeFromUrl } from '../tracker/getPageTypeFromUrl';
import { removeHyphens } from './utils/removeHyphens';

export const getImpresionEvent = (dataPCT: {
  isInContentTileMode: boolean;
  isPersonalized: boolean;
  previouslyVisited: string[];
  tiles: Tile[];
}) => {
  const tiles = dataPCT.tiles.map((data, index) => {
    const modelName = getModelNameFromUrl(data.CTA.href);

    return {
      modelName: modelName ? removeHyphens(modelName) : null,
      targetPage: getPageTypeFromUrl(data.CTA.href),
      position: index + 1,
      personalized: dataPCT.isPersonalized,
    };
  });
  return {
    eventInfo: {
      eventAction: 'impression',
      eventName: 'personalized content tiles - impression',
    },
    attributes: {
      type: 'personalizedTiles|Impression',
      payload: {
        tiles,
        previouslyVisted: getPreviouslyVisited(),
        featureApp: {
          name: 'Personalized Content Tiles', // appStore.title
          id: 'a146211c-ca73-4e7a-9e70-5f22661e53e1', // appStore.appId
          baseUrl: 'https://fa-content-tiles-personalized.cdn.prod.collab.apps.one.audi/', // appStore.extra.featureHub.baseUrl
        },
      },
    },
  };
};
